module.exports = __webpack_public_path__ + "img/IZIBOX-LOGO.cb0ee4fe.png";